import React from 'react';
import { Edit, SimpleForm, TextInput, NumberInput, ResourceContextProvider } from 'react-admin';
import Heading from 'components/Heading';
import EnumSelectInput from 'components/Enum/EnumSelectInput';
import { createConditionalInputWrapper } from 'hoc/createConditionalInputWrapper';
import RejectionReasonField from 'resources/assignment_requests/RejectionReasonField';
import { transformPayload } from 'resources/assignment_requests/utils';
import DisableableDateInput from 'components/DisableableDateInput';

const HideIfApplicationNonRejected = createConditionalInputWrapper(
  (formData) => formData.vms_application_status === 'rejected',
);

const HideIfProfileNonRejected = createConditionalInputWrapper(
  (formData) => formData.vms_profile_status === 'rejected',
);

const PermanentRequestsEdit = () => (
  <Edit
    transform={transformPayload}
    mutationMode="pessimistic"
    redirect="show"
    data-testid="permanent-requests-edit"
  >
    <SimpleForm>
      <NumberInput label="Referrer ID" source="referrer_professional_id" />
      <Heading>Professional Application</Heading>
      <TextInput label="Interview Availability" source="interview_availability" />
      <TextInput label="Professional Prev. Worked Here" source="professional_prev_worked_here" />
      <DisableableDateInput
        disableLabel="ASAP"
        dateSource="preferred_start_date"
        disableSource="asap"
      />
      <TextInput label="Time Off Request" source="time_off_request" />
      <TextInput label="Exceptions" source="exceptions" />
      <EnumSelectInput resource="AssignmentRequest" label="Bonus Type" source="bonus_type" />
      <EnumSelectInput
        resource="AssignmentRequest"
        label="Application Status"
        source="status"
      />
      <ResourceContextProvider value="AssignmentRequest">
        <RejectionReasonField />
      </ResourceContextProvider>
      <TextInput label="Note" source="note" fullWidth multiline />
      <EnumSelectInput
        resource="AssignmentRequest"
        label="Offer Source"
        source="offer_source"
        sort={false}
      />
      <Heading>Professional Profile</Heading>
      <EnumSelectInput
        resource="AssignmentRequest"
        label="Professional Profile Status"
        source="vms_profile_status"
      />
      <HideIfProfileNonRejected>
        <EnumSelectInput
          resource="AssignmentRequest"
          label="Profile Rejected by CAM reason"
          source="cam_reject_reason"
          sort={false}
        />
      </HideIfProfileNonRejected>
      <EnumSelectInput
        resource="AssignmentRequest"
        label="Contract Type"
        source="contract_type"
        resettable
      />
      <TextInput label="Recruiter Notes" source="recruiter_notes" fullWidth multiline />
      <Heading>VMS Application Status</Heading>
      <EnumSelectInput
        resource="AssignmentRequest"
        label="VMS Application Status"
        source="vms_application_status"
      />
      <HideIfApplicationNonRejected>
        <EnumSelectInput
          resource="AssignmentRequest"
          label="Rejected by VMS reason"
          source="vms_reject_reason"
        />
      </HideIfApplicationNonRejected>
      <TextInput label="CAM Notes" source="cam_notes" fullWidth multiline />
    </SimpleForm>
  </Edit>
);

export default PermanentRequestsEdit;
